const FilterListSkeleton: React.FC = props => {
  return (
    <div className="overflow-hidden h-9 flex items-center px-2">
      {[1, 2, 3].map((item, index) => {
        return (
          <div key={`${index}-${item}`} className="w-[60px] h-[20px] box-border bg-surface-200-bg ml-3 skeleton"></div>
        );
      })}
    </div>
  );
};

export default FilterListSkeleton;
